// extracted by mini-css-extract-plugin
export default {"dialog_content":"codeDialog_dialog_content__p0Of2"};